import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { retrieveUsers } from "../../../redux/actions/users";

const Filter = (props) => {
  const dispatch = useDispatch();
  const [ready, setReady] = useState(false);
  const { fullList } = useSelector((state) => state);
  const [form, setForm] = useState({ filter: {}, offset: 0, limit: 10 });
  let arr = { ...form };
  let initFunction = () => {
    setReady(false);
    if (localStorage.getItem("coordinatorsFilter")) {
      arr.filter = JSON.parse(localStorage.getItem("coordinatorsFilter"));
      setForm(arr);
    }
    setReady(true);
  };

  const saveFilter = (data) => {
    if (data) {
      let val = data;
      val.filter["roleId"] = [];
      val.filter["roleId"].push("09efbeb2-f45a-418d-89b0-b2a4c37f6122");
      props.setFilter(data.filter);
      dispatch(retrieveUsers(val)).then((res) => {
        if (props.initFunction) {
          props.initFunction(res);
        }
      });
    } else {
      let val = form;
      props.setFilter(form.filter);

      val.filter["roleId"] = [];
      val.filter["roleId"].push("09efbeb2-f45a-418d-89b0-b2a4c37f6122");
      dispatch(retrieveUsers(val)).then((res) => {
        if (props.initFunction) {
          props.initFunction(res);
        }
      });
    }
  };

  useEffect(() => {
    if (!ready) {
      initFunction();
    }
  }, []);

  const setSelect = (e) => {
    arr = { ...form };

    if (
      arr.filter[e.target.accessKey] &&
      arr.filter[e.target.accessKey].includes(e.target.id)
    ) {
      const index = arr.filter[e.target.accessKey].indexOf(e.target.id);
      if (index > -1) {
        arr.filter[e.target.accessKey].splice(index, 1);
      }
    } else {
      if (arr.filter[e.target.accessKey]) {
        arr.filter[e.target.accessKey].push(e.target.id);
      } else {
        arr.filter[e.target.accessKey] = [];
        arr.filter[e.target.accessKey].push(e.target.id);
      }
    }

    setForm(arr);
  };
  const leaveClick = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      localStorage.setItem("coordinatorsFilter", JSON.stringify(form.filter));
      saveFilter();
      props.setModal(false);
    }
  };
  const resetClick = () => {
    arr = { filter: [] };
    setForm(arr);
    localStorage.removeItem("coordinatorsFilter");
    saveFilter(arr);
  };

  return (
    <div className="apFilterContainer" onBlur={leaveClick} tabIndex="0">
      <div className="apFilterHeader">
        <h4>Параметри фільтра</h4>
        <div style={{ display: "flex" }}>
          <button
            style={{ marginRight: "20px" }}
            className="secondarySmallRoundedButtonTextDefault"
            onClick={resetClick}
          >
            Скинути
          </button>
          <button
            className="secondarySmallRoundedButtonTextDefault"
            onClick={leaveClick}
          >
            OK
          </button>
        </div>
      </div>
      <div className="apFilterGroupBlock">
        <span>Регіони</span>
        <div className="apFilterButtonsBlock">
          {fullList.Regions.map((el, index) => {
            return (
              <button
                key={index}
                id={el.id}
                accessKey="regionId"
                className={
                  form.filter.regionId &&
                  form.filter.regionId.length > 0 &&
                  form.filter.regionId.includes(el.id)
                    ? "secondarySmallButtonTextActive"
                    : "secondarySmallButtonTextDefault"
                }
                onClick={setSelect}
              >
                {el.title}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Filter;
